var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalenderIconSelect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 6,
    fill: "url(#paint0_linear_1_1375)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 8.33333V9.66666H16.9999V8.33333H18.3333V9.66666H20.9999C21.3681 9.66666 21.6666 9.96514 21.6666 10.3333V21C21.6666 21.3682 21.3681 21.6667 20.9999 21.6667H8.99992C8.63173 21.6667 8.33325 21.3682 8.33325 21V10.3333C8.33325 9.96514 8.63173 9.66666 8.99992 9.66666H11.6666V8.33333H12.9999ZM20.3333 15H9.66659V20.3333H20.3333V15ZM11.6666 11H9.66659V13.6667H20.3333V11H18.3333V12.3333H16.9999V11H12.9999V12.3333H11.6666V11Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1375",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#600EC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87109F"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalenderIconSelect);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calender-icon-select.852a0f69ef815b3803df22e58170f137.svg";